import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import BusinessTable from './BusinessTable';

interface IBusinessProps extends RouteComponentProps<{
  eshop: string;
  businessId: string;
}> {

}

export default class Business extends React.Component<IBusinessProps> {

  render() {
    return (
      <div>
        <BusinessTable
          domain={this.props.match.params.eshop}
          businessId={this.props.match.params.businessId}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/scenes/Business/index.tsx